export default class VoyageRouteData {
  constructor(voyageId, computation, routes) {
    this.voyageId = voyageId,
    this.computation = computation,
    this.routes = routes;
  }

    _timeFormatOptions = { hour: "2-digit", minute: "2-digit", hour12: false };

    _getFeaturesDataList(routeData) {
      return routeData !== undefined && routeData !== null
        ? routeData.data.map((datum) => ({
          "coordinates": [datum.longitude, datum.latitude],
          "position": `${datum.positionId}`,
          "time": new Date(datum.timestamp).toLocaleTimeString("en-GB", this._timeFormatOptions),
          "date": new Date(datum.timestamp).toLocaleDateString("en-GB", this._dateFormatOptions),
          "speed": datum.speed,
          "direction": datum.direction,
          "dailyFuelConsumption": datum.operational.dailyFuelConsumption
        }))
        : [];

    }

    _getSpeedSeriesData(routeData) {
      return routeData.data.map((datum) => {
        if (datum.speed != undefined && datum.speed != null && datum.speed !== 0) {
          const timestamp = new Date(datum.timestamp).getTime();
          const speed = datum.speed;
          return [timestamp, speed];
        }
      });
    }

    _getDailyConsumptionSeriesData(routeData) {
      return routeData.data.map((datum) => {
        if (datum.operational.dailyFuelConsumption != undefined && datum.operational.dailyFuelConsumption != null && datum.operational.dailyFuelConsumption !== 0) {
          const timestamp = new Date(datum.timestamp).getTime();
          const dailyFuelConsumption = datum.operational.dailyFuelConsumption;
          return [timestamp, dailyFuelConsumption];
        }
      });

    }

    get foaDailyConsumptionSeriesData() {
      const foaRouteData = this.routes.find((route) => route.tag == "foa");
      return foaRouteData != null ? this._getDailyConsumptionSeriesData(foaRouteData) : [];
    }

    get minFuelDailyConsumptionSeriesData() {
      const minFuelRouteData = this.routes.find((route) => route.tag == "min_fuel");
      return minFuelRouteData != null ? this._getDailyConsumptionSeriesData(minFuelRouteData) : [];
    }

    get minTimeDailyConsumptionSeriesData() {
      const minTimeRouteData = this.routes.find((route) => route.tag == "min_time");
      return minTimeRouteData != null ? this._getDailyConsumptionSeriesData(minTimeRouteData) : [];
    }

    get bestTceDailyConsumptionSeriesData() {
      const bestTceRouteData = this.routes.find((route) => route.tag == "best_tce");
      return bestTceRouteData != null ? this._getDailyConsumptionSeriesData(bestTceRouteData) : [];
    }

    get bestDtaDailyConsumptionSeriesData() {
      const bestDtaRouteData = this.routes.find((route) => route.tag == "best_dta");
      return bestDtaRouteData != null ? this._getDailyConsumptionSeriesData(bestDtaRouteData) : [];
    }

    get foaSpeedSeriesData() {
      const foaRouteData = this.routes.find((route) => route.tag == "foa");
      return foaRouteData != null ? this._getSpeedSeriesData(foaRouteData) : [];
    }

    get minFuelSpeedSeriesData() {
      const minFuelRouteData = this.routes.find((route) => route.tag == "min_fuel");
      return minFuelRouteData != null ? this._getSpeedSeriesData(minFuelRouteData) : [];
    }

    get minTimeSpeedSeriesData() {
      const minTimeRouteData = this.routes.find((route) => route.tag == "min_time");
      return minTimeRouteData != null ? this._getSpeedSeriesData(minTimeRouteData) : [];
    }

    get bestTceSpeedSeriesData() {
      const bestTceRouteData = this.routes.find((route) => route.tag == "best_tce");
      return bestTceRouteData != null ? this._getSpeedSeriesData(bestTceRouteData) : [];
    }

    get bestDtaSpeedSeriesData() {
      const bestDtaRouteData = this.routes.find((route) => route.tag == "best_dta");
      return bestDtaRouteData != null ? this._getSpeedSeriesData(bestDtaRouteData) : [];
    }

    get foaFeaturesDataList() {
      const foaRouteData = this.routes.find((route) => route.tag == "foa");
      return this._getFeaturesDataList(foaRouteData);
    }

    get minFuelFeaturesDataList() {
      const minFuelData = this.routes.find((route) => route.tag == "min_fuel");

      return this._getFeaturesDataList(minFuelData);
    }

    get bestTceFeaturesDataList() {
      const bestTceData = this.routes.find((route) => route.tag == "best_tce");
      return this._getFeaturesDataList(bestTceData);
    }

    get minTimeFeaturesDataList() {
      const minTimeData = this.routes.find((route) => route.tag == "min_time");
      return this._getFeaturesDataList(minTimeData);
    }

    get bestDtaFeaturesDataList() {
      const bestDtaData = this.routes.find((route) => route.tag == "best_dta");
      return this._getFeaturesDataList(bestDtaData);
    }

    get foaFeatures() {
      const foaRouteData = this.routes.find((route) => route.tag == "foa");
      return foaRouteData.features;
    }

    get minFuelFeatures() {
      const minFuelData = this.routes.find((route) => route.tag == "min_fuel");
      return minFuelData.features;
    }

    get minTimeFeatures() {
      const minTimeData = this.routes.find((route) => route.tag == "min_time");
      return minTimeData.features;
    }

    get bestTceFeatures() {
      const bestTceData = this.routes.find((route) => route.tag == "best_tce");
      return bestTceData.features;
    }

    get bestDtaFeatures() {
      const bestDtaData = this.routes.find((route) => route.tag == "best_dta");
      return bestDtaData != null ? bestDtaData.features : null;
    }

    get foaVoyageStartDate() {
      const foaRouteData = this.routes.find((route) => route.tag === "foa");

      if (!foaRouteData || !Array.isArray(foaRouteData.data) || foaRouteData.data.length === 0) {
        return null;
      }

      const firstPoint = foaRouteData.data[0];

      if (!firstPoint || !firstPoint.etd) {
        return null;
      }

      return firstPoint.etd.substring(0, 8);
    }

    get foaVoyageEndDate() {
      const foaRouteData = this.routes.find((route) => route.tag === "foa");

      if (!foaRouteData || !Array.isArray(foaRouteData.data) || foaRouteData.data.length === 0) {
        return null;
      }

      const lastPoint = foaRouteData.data[foaRouteData.data.length - 1];

      if (!lastPoint || !lastPoint.etd) {
        return null;
      }

      return lastPoint.etd.substring(0, 8);
    }

    get minFuelVoyageStartDate() {
      const minFuelData = this.routes.find((route) => route.tag == "min_fuel");
      const firstPoint = minFuelData.data[0];

      return firstPoint.etd.substring(0, 8);
    }

    get minFuelVoyageEndDate() {
      const minFuelData = this.routes.find((route) => route.tag == "min_fuel");
      const lastPoint = minFuelData.data.slice(-1)[0];
      return lastPoint.etd.substring(0, 8);
    }

    get minTimeVoyageStartDate() {
      const minTimeData = this.routes.find((route) => route.tag == "min_time");
      const firstPoint = minTimeData.data[0];

      return firstPoint.etd.substring(0, 8);
    }

    get minTimeVoyageEndDate() {
      const minTimeData = this.routes.find((route) => route.tag == "min_time");
      const lastPoint = minTimeData.data.slice(-1)[0];

      return lastPoint.etd.substring(0, 8);
    }

    get bestTceStartDate() {
      const bestTceData = this.routes.find((route) => route.tag == "best_tce");
      const firstPoint = bestTceData.data[0];

      return firstPoint.etd.substring(0, 8);
    }

    get bestTceEndDate() {
      const bestTceData = this.routes.find((route) => route.tag == "best_tce");
      const lastPoint = bestTceData.data.slice(-1)[0];

      return lastPoint.etd.substring(0, 8);
    }

    get bestDtaStartDate() {
      const bestDtaData = this.routes.find((route) => route.tag == "best_dta");
      if (bestDtaData == undefined || bestDtaData == null) {
        return null;
      }
      const firstPoint = bestDtaData.data[0];

      return firstPoint.etd.substring(0, 8);
    }

    get bestDtaEndDate() {
      const bestDtaData = this.routes.find((route) => route.tag == "best_dta");
      if (bestDtaData == undefined || bestDtaData == null) {
        return null;
      }
      const lastPoint = bestDtaData.data.slice(-1)[0];

      return lastPoint.etd.substring(0, 8);
    }

    get voyageStartDate() {
      const foaRouteData = this.routes.find((route) => route.tag === "foa");

      if (!foaRouteData || !Array.isArray(foaRouteData.data) || foaRouteData.data.length === 0) {
        return null;
      }

      const firstPoint = foaRouteData.data[0];

      if (!firstPoint || !firstPoint.timestamp) {
        return null;
      }

      const date = new Date(firstPoint.timestamp);
      date.setDate(date.getDate() + 1);

      return date.toISOString().substring(0, 10);
    }
}
